import React from 'react';

import { PkpassDate } from '../../../../../inputs';
import valueHelper from './valueHelper';

export default function FieldTypeDateValue(): JSX.Element {
  return (
    <PkpassDate required={true} name={`properties.value`} {...valueHelper} />
  );
}
